import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/aspOption', request)
}

export {get}
